class LookbookShopTheLook extends HTMLElement {
    constructor() {
        super();

        this.swiperShopTheLook = this.querySelector('.swiper-lookbook-shop-the-look');
        this.swiperPagination = this.querySelector('.swiper-lookbook-shop-the-look-pagination');
        this.shopTheLookSlides = this.querySelectorAll('.shop-the-look-slide');
        this.lookbokProducts = document.querySelectorAll('.lookbook-collection [data-product-card-title]');
    
        this.swiper = new Swiper(this.swiperShopTheLook, {
            slidesPerView: 1,
            spaceBetween: 10,
            preventClicks: true,
            preventClicksPropagation: true,
            grabCursor: true,
            pagination: {
                el: this.swiperPagination,
                type: "fraction",
            },
            navigation: {
                nextEl: this.querySelector('.swiper-lookbook-shop-the-look-next'),
                prevEl: this.querySelector('.swiper-lookbook-shop-the-look-prev'),
            }
        });

        if (this.getAttribute('enable-lookbook-matching') == 'true') {
            this.matchShopTheLookSlides();
        }
    }

    matchShopTheLookSlides() {
        let productCardCompareArr = [];

        document.querySelector('.lookbook-collection').addEventListener('click', (event) => {
            this.shopTheLookSlides.forEach((shopTheLookSlide) => { 
                if (event.target.closest('[data-product-card-title]')) {
                    if (event.target.closest('[data-product-card-title]').getAttribute('data-product-card-title') == shopTheLookSlide.getAttribute('data-shop-the-look-product-title')) {
                        this.swiper.slideTo(shopTheLookSlide.getAttribute('swiper-index'), 500);
                        this.scrollIntoView({
                            behavior: 'smooth'
                        });
                    }
                }
            });
        });

        this.shopTheLookSlides.forEach((shopTheLookSlide) => {
            this.lookbokProducts.forEach((lookbokProduct) => {
                productCardCompareArr.push(lookbokProduct.getAttribute('data-product-card-title'));

                if (this.getAttribute('enable-optional-images') == 'false') {
                    if (lookbokProduct.getAttribute('data-product-card-title') == shopTheLookSlide.getAttribute('data-shop-the-look-product-title')) {
                        shopTheLookSlide.querySelector('.cover-image img.desktop').src = lookbokProduct.querySelector('img').src;
                        shopTheLookSlide.querySelector('.cover-image img.desktop').setAttribute('alt', lookbokProduct.querySelector('img').getAttribute('alt'));
                        shopTheLookSlide.querySelector('.cover-image img.mobile').src = lookbokProduct.querySelector('img').src;
                        shopTheLookSlide.querySelector('.cover-image img.mobile').setAttribute('alt', lookbokProduct.querySelector('img').getAttribute('alt'));
                    }
                }

            });
        })
    }
}

customElements.define('lookbook-shop-the-look', LookbookShopTheLook);